export enum ReportUrlPrefix {
  Activities = "activities/export",
  Programs = "programs/export",
  ProgramComments = "program_comments/export",
}
